export var NavigationItemId;
(function (NavigationItemId) {
    NavigationItemId[NavigationItemId["NEW_CALCULATION"] = 0] = "NEW_CALCULATION";
    NavigationItemId[NavigationItemId["MY_CALCULATIONS"] = 1] = "MY_CALCULATIONS";
    NavigationItemId[NavigationItemId["MY_ACCOUNT"] = 2] = "MY_ACCOUNT";
})(NavigationItemId || (NavigationItemId = {}));
